import React, { useCallback } from 'react';
import { useController } from 'react-hook-form';
import Checkbox from '../checkbox';
import CheckboxGroup from '../checkbox-group';
import FieldStatus from '../field-status';
import noop from '../../../utils/noop';
const defaultRules = {};

const CheckboxGroupField = ({ name, options, control, rules = defaultRules, onChange = noop }) => {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  const handleChange = useCallback(
    (isChecked, value) => {
      const current = field.value || [];
      const newValue = isChecked ? [...current, value] : current.filter((item) => item !== value);
      field.onChange(newValue);
      if (onChange) onChange(newValue, isChecked, value);
    },
    [field, onChange]
  );

  return (
    <CheckboxGroup>
      {options.map(({ label, value, ...otherProps }, index) => {
        const id = `${field.name}-${index}`;
        const checked = (field.value || []).includes(value);

        return (
          <Checkbox
            {...otherProps}
            {...(index === 0 && { inputRef: field.ref })}
            key={id}
            id={id}
            name={id}
            label={label}
            value={value}
            checked={checked}
            onChange={handleChange}
          />
        );
      })}
      {fieldState.error && <FieldStatus appearance="error" text={fieldState.error.message} />}
    </CheckboxGroup>
  );
};

export default CheckboxGroupField;
